import MenuManager from '@yooink/youtils/es/MenuManager';
import { GiStorkDelivery } from 'react-icons/gi';
import { FaCar, FaMapPin } from 'react-icons/fa';
import { Route } from 'react-router-dom';
import { PickupPointsRoute } from './PickupPoints/pickupPointsRoute';
import { CouriersRoute } from './Couriers/couriersRoute';
import { FiasToPostalCodeListAsEditableTable } from '../FiasToPostalCode/ListAsEditableTable';

MenuManager.RegisterGroup({
	key: 'pickupPoints',
	name: 'Доставка',
	icon: <GiStorkDelivery />,
	position: 9
}, [
	{
		path: '/delivery/pickuppoints',
		name: 'Точки самовывоза',
		icon: <FaMapPin />
	},
	{
		path: '/delivery/couriers',
		key: 'couriers',
		name: 'Курьеры',
		icon: <FaCar />
	},
	{
		path: '/delivery/fixPostalCode',
		key: 'fix-postal-codes',
		name: 'Фикс почтовых индексов'
	}
]);

export function SelfDeliveryRouter () {
	function getUrl (...paths) {
		return `/delivery/${paths.join('/')}`;
	}

	return (
		<>
			<PickupPointsRoute path={getUrl('pickuppoints')} />
			<CouriersRoute path={getUrl('couriers')} />
			<Route exact path={getUrl('fixPostalCode')} component={FiasToPostalCodeListAsEditableTable} />
		</>
	);
}
